import { useEffect, useState } from 'react'
import { Field } from '@progress/kendo-react-form'
import { MultiSelect } from '@progress/kendo-react-dropdowns'
import { Label } from '@progress/kendo-react-labels'

import {
  FormInput,
  FormNumericTextBox,
  FormDropDownList,
  FormDropDownListFilter,
  FormDatePicker,
  FormMultiSelect
} from '../FormComponents'
import { requiredValidator } from '../Validators'
import { getNotifiableWorks } from '../../../data/notifiableWorkData'

const JobConvertForm = (props: any) => {

  const [convertData, setConvertData] = useState({
    purchaseOrder: '',
    proformaCost: 0,
    worktypeId: {
      text: '',
      value: 0,
    },
    departmentId: {
      text: '',
      value: 0,
    },
    cost: 0,
    startDate: '',
    endDate: '',
    employeeProjectmanager: {
      text: '',
      value: 0,
    },
    jobEmployeeIds: [{ value: 0, text: '' }],
  })

  // Asked for here as well as on the quote conversion: a job needs its
  // notifiable works recorded however it came into being.
  const [notifiableWorksOptions, setNotifiableWorksOptions] = useState<string[]>([])
  const [notifiableWorks, setNotifiableWorks] = useState<string[]>([])

  useEffect(() => {
    getNotifiableWorks()
      .then(setNotifiableWorksOptions)
      .catch((error) => console.error('Error loading notifiable works:', error))
  }, [])

  const handleJobConvert = () => {
    if (notifiableWorks.length === 0) {
      // Matches the quote conversion, which refuses for the same reason.
      props.onNotifiableWorksMissing?.()
      return
    }

    props.onHandleConvertSubmit({ ...convertData, notifiableWorks })
  }

   return (
      <div>
         <legend
          className={'k-form-legend'}
          style={{
            color: 'rgb(36,32,56)',
            paddingBottom: '1rem',
            fontWeight: 'bold',
            marginTop: '2rem',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          Convert to job:
        </legend>

        <Field
                  name={'purchaseOrder'}
                  component={FormInput}
                  label={'Purchase Order/Works Order:'}
                  placeholder={'Enter a PO/WO number:'}
                  onChange={(e) => {
                    setConvertData({ ...convertData, purchaseOrder: e.value })
                  }}
                />

                <Field
                  name={'proformaCost'}
                  component={FormNumericTextBox}
                  label={'Enter proforma invoice value:'}
                  onChange={(e) => {
                    setConvertData({ ...convertData, proformaCost: e.value })
                  }}
                />

                <Field
                  data={props.onWorktypeData}
                  name={'worktypeId'}
                  component={FormDropDownList}
                  label={'Choose the type of work:'}
                  onChange={(e) => {
                    setConvertData({
                      ...convertData,
                      worktypeId: {
                        ...e.value,
                        value: parseInt(e.value.value, 10),
                      },
                    })
                  }}
                />

                <Field
                  data={props.onDepartmentData}
                  name={'departmentId'}
                  component={FormDropDownList}
                  label={'Choose the department:'}
                  onChange={(e) => {
                    setConvertData({
                      ...convertData,
                      departmentId: {
                        ...e.value,
                        value: parseInt(e.value.value, 10),
                      },
                    })
                  }}
                />

                <Field
                  name={'cost'}
                  component={FormNumericTextBox}
                  label={'Enter total value:'}
                  onChange={(e) => {
                    setConvertData({ ...convertData, cost: e.value })
                  }}
                />

                <Field
                  name={'startDate'}
                  component={FormDatePicker}
                  label={'Choose start date:'}
                  onChange={(e) => {
                    setConvertData({ ...convertData, startDate: e.value })
                  }}
                />

                <Field
                  name={'endDate'}
                  component={FormDatePicker}
                  label={'Choose end date:'}
                  onChange={(e) => {
                    setConvertData({ ...convertData, endDate: e.value })
                  }}
                />

                <Field
                  data={props.onEmployeeProjectData}
                  originalData={props.onEmployeeDataOrig}
                  name={'employeeProjectmanager'}
                  component={FormDropDownListFilter}
                  searchDropdown={props.onSearchEmployeeProjectDropdown}
                  label={'Choose project manager:'}
                  setData={props.onSetEmployeeData}
                  onChange={(e) => {
                    setConvertData({
                      ...convertData,
                      employeeProjectmanager: {
                        ...e.value,
                        value: parseInt(e.value.value, 10),
                      },
                    })
                  }}
                />

                {/* <Field
                  data={props.onEmployeeData}
                  originalData={props.onEmployeeDataOrig}
                  name={'jobEmployeeIds'}
                  component={FormMultiSelect}
                  searchDropdown={props.onSearchEmployeeDropdown}
                  label={'Choose assigned employees:'}
                  onChange={(e) => {
                    const updatedJobEmployeeIds = e.value.map((item: any) => ({
                      value: parseInt(item.value, 10),
                      text: item.text,
                    }))

                    setConvertData({
                      ...convertData,
                      jobEmployeeIds: updatedJobEmployeeIds,
                    })
                  }}
                /> */}

        <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
          <Label>Notifiable Works:</Label>
          <MultiSelect
            data={notifiableWorksOptions}
            value={notifiableWorks}
            onChange={(e) => setNotifiableWorks(e.value)}
            placeholder='Select notifiable works...'
            required={true}
            valid={notifiableWorks.length > 0}
          />
          {notifiableWorks.length === 0 && (
            <div style={{ color: '#d32f2f', fontSize: '0.75rem', marginTop: '0.25rem' }}>
              Please select at least one notifiable work.
            </div>
          )}
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            padding: '1rem 2rem 1rem 2rem',
            position: 'relative',
            zIndex: '150',
          }}
        >
          <button
            onClick={handleJobConvert}
            className='form__edit__button accept'
          >
            Create Job
          </button>
          <button
            onClick={props.onHandleConvertDisplay}
            className='form__edit__button reject'
          >
            Cancel Convert
          </button>
        </div>
      </div>
   );
}

export default JobConvertForm;